import React from "react";

// assets
import StoreHeaderBagIcon from "bodycodi/cmap/app/img/store_header_bag_icon.png";
import StoreHeaderBShopIcon from "bodycodi/cmap/app/svg/store_header_bshop_icon.svg";
import RightIcon from "bodycodi/cmap/app/svg/right_icon_small_white.svg";
import ChuseokBanner from "bodycodi/cmap/app/img/store_chuseok_event.png";

const StoreHeader = () => {
  const EVENT_OFF = new Date("2023-09-25").getTime();
  const isEventTime = new Date().getTime() < EVENT_OFF;

  const handleClickHeader = () => {
    if (window.ReactNativeWebView) {
      const data = JSON.stringify({
        type: "openExternalLink",
        link: isEventTime
          ? "https://crm-guide.bodycodi.com/chuseok"
          : "https://m.smartstore.naver.com/bodycodi",
      });
      window.ReactNativeWebView.postMessage(data);
    } else {
      window.location.href = isEventTime
        ? "https://crm-guide.bodycodi.com/chuseok"
        : "https://m.smartstore.naver.com/bodycodi";
    }
  };

  if (isEventTime) {
    return (
      <div className="store-chuseok-event" onClick={handleClickHeader}>
        <div className="text">
          <span className="orange">종료 임박! 최대 55% 할인</span>
          <span className="white">온라인 최저가 다이어트 · 건강 기획전</span>
        </div>
        <img src={ChuseokBanner} alt="chuseok_event" />
      </div>
    );
  }

  return (
    <div className="store-header" onClick={handleClickHeader}>
      <div className="wrapper">
        <img src={StoreHeaderBagIcon} />
        <span className="long">오직 바디코디 가맹점만!</span>
        <img src={StoreHeaderBShopIcon} />

        <div className="button">
          <span>특별혜택</span>
          <img src={RightIcon} />
        </div>
      </div>
    </div>
  );
};

export default StoreHeader;
